
{
  "familyId": "GET-BREUK-GEL-MIN",
  "questions": [
    {
      "id": "GET-BREUK-GEL-MIN-001",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{3}{4}$ - $\\frac{1}{4}$ =",
      "context": null,
      "options": ["$\\frac{2}{4}$", "$\\frac{4}{8}$", "$\\frac{2}{8}$", "$\\frac{4}{4}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_quarters",
      "variantIndex": 1,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 3, "denominator": 4, "label": "3/4"},
              {"numerator": 1, "denominator": 4, "label": "1/4"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 4,
            "label": "3/4 - 1/4 = 2/4",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{2}{4}$. Bij gelijknamige breuken trek je de tellers af: 3 - 1 = 2. De noemer blijft hetzelfde: 4. Dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$ (= $\\frac{1}{2}$).",
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 3 - 1 = 2, noemer blijft 4. Dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$.",
          "1": "$\\frac{4}{8}$ is fout. Je hebt de noemers ook opgeteld (4 + 4 = 8). Dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde: $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$.",
          "2": "$\\frac{2}{8}$ is fout. Je hebt de tellers correct afgetrokken (3 - 1 = 2), maar ook de noemers opgeteld (4 + 4 = 8). De noemer blijft 4, niet 8.",
          "3": "$\\frac{4}{4}$ is fout. Je hebt de tellers opgeteld (3 + 1 = 4) in plaats van afgetrokken. Trek af: 3 - 1 = 2, dus $\\frac{3}{4}$ - $\\frac{1}{4}$ = $\\frac{2}{4}$."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-002",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{4}{5}$ - $\\frac{2}{5}$ =",
      "context": null,
      "options": ["$\\frac{2}{5}$", "$\\frac{2}{10}$", "$\\frac{6}{5}$", "$\\frac{2}{0}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_fifths",
      "variantIndex": 2,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 4, "denominator": 5, "label": "4/5"},
              {"numerator": 2, "denominator": 5, "label": "2/5"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "4/5 - 2/5 = 2/5",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{2}{5}$. Trek de tellers af: 4 - 2 = 2. De noemer blijft 5. Dus $\\frac{4}{5}$ - $\\frac{2}{5}$ = $\\frac{2}{5}$.",
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 4 - 2 = 2, noemer blijft 5. Dus $\\frac{4}{5}$ - $\\frac{2}{5}$ = $\\frac{2}{5}$.",
          "1": "$\\frac{2}{10}$ is fout. Je hebt de noemers ook opgeteld (5 + 5 = 10). Dat mag niet. Bij gelijknamige breuken blijft de noemer hetzelfde: 5.",
          "2": "$\\frac{6}{5}$ is fout. Je hebt de tellers opgeteld (4 + 2 = 6) in plaats van afgetrokken. Trek af: 4 - 2 = 2.",
          "3": "$\\frac{2}{0}$ is fout. Je hebt de noemers afgetrokken (5 - 5 = 0). De noemer verandert niet bij aftrekken van gelijknamige breuken — hij blijft 5."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-003",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Reken uit: $\\frac{5}{6}$ - $\\frac{3}{6}$ =",
      "context": null,
      "options": ["$\\frac{2}{6}$", "$\\frac{2}{12}$", "$\\frac{8}{6}$", "$\\frac{3}{6}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_sixths",
      "variantIndex": 3,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 5, "denominator": 6, "label": "5/6"},
              {"numerator": 3, "denominator": 6, "label": "3/6"}
            ],
            "operator": "-",
            "visualType": "bar"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 6,
            "label": "5/6 - 3/6 = 2/6",
            "visualType": "bar"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{2}{6}$. Trek de tellers af: 5 - 3 = 2. De noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{3}{6}$ = $\\frac{2}{6}$ (= $\\frac{1}{3}$).",
        "distractorExplanations": {
          "0": "Goed! Trek de tellers af: 5 - 3 = 2, noemer blijft 6. Dus $\\frac{5}{6}$ - $\\frac{3}{6}$ = $\\frac{2}{6}$.",
          "1": "$\\frac{2}{12}$ is fout. Je hebt de noemers ook opgeteld (6 + 6 = 12). Dat mag niet. De noemer blijft 6.",
          "2": "$\\frac{8}{6}$ is fout. Je hebt de tellers opgeteld (5 + 3 = 8) in plaats van afgetrokken. Trek af: 5 - 3 = 2.",
          "3": "$\\frac{3}{6}$ is fout. Je hebt alleen de tweede breuk genomen als antwoord. Trek de tellers af: 5 - 3 = 2, dus $\\frac{2}{6}$."
        }
      }
    },
    {
      "id": "GET-BREUK-GEL-MIN-004",
      "familyId": "GET-BREUK-GEL-MIN",
      "module": "Getalbegrip",
      "tier": 2,
      "levelCode": "B6+",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_aftrekken_gel",
      "questionType": "multiple_choice",
      "question": "Er is $\\frac{7}{8}$ van een taart over. Je eet $\\frac{3}{8}$. Hoeveel taart is er nog over?",
      "context": null,
      "options": ["$\\frac{4}{8}$", "$\\frac{4}{16}$", "$\\frac{10}{8}$", "$\\frac{3}{8}$"],
      "correctAnswer": 0,
      "conceptId": "subtract_like_fractions_context",
      "variantIndex": 4,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "fractions": [
              {"numerator": 7, "denominator": 8, "label": "Over: 7/8"},
              {"numerator": 3, "denominator": 8, "label": "Gegeten: 3/8"}
            ],
            "operator": "-",
            "visualType": "circle"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 8,
            "label": "7/8 - 3/8 = 4/8 van de taart is nog over",
            "visualType": "circle"
          }
        }
      ],
      "feedback": {
        "explanationText": "Het goede antwoord is $\\frac{4}{8}$. Er was $\\frac{7}{8}$ over en je eet $\\frac{3}{8}$. Trek de tellers af: 7 - 3 = 4. De noemer (8 stukken) blijft hetzelfde. Dus $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$ (= $\\frac{1}{2}$).",
        "distractorExplanations": {
          "0": "Goed! 7 - 3 = 4, noemer blijft 8. Er is $\\frac{4}{8}$ (= een halve) taart over.",
          "1": "$\\frac{4}{16}$ is fout. Je hebt de noemers ook opgeteld (8 + 8 = 16). Maar de taart is in 8 stukken verdeeld, niet 16. De noemer blijft 8.",
          "2": "$\\frac{10}{8}$ is fout. Je hebt de tellers opgeteld (7 + 3 = 10) in plaats van afgetrokken. Je eet stukken op, dus trek af: 7 - 3 = 4.",
          "3": "$\\frac{3}{8}$ is het deel dat je hebt gegeten, niet wat er over is. Trek af: $\\frac{7}{8}$ - $\\frac{3}{8}$ = $\\frac{4}{8}$."
        }
      }
    }
  ]
}
